const COUNT_STORAGE_KEY = 'premium_ss_modal_count';

export { COUNT_STORAGE_KEY };
